export const checkTruncation = (textRefs: (HTMLDivElement | null)[]) => {
  const newTruncatedState: { [key: number]: boolean } = {};
  textRefs.forEach((ref, index) => {
    if (ref) {
      const isTextTruncated = ref.scrollWidth > ref.clientWidth;
      newTruncatedState[index] = isTextTruncated;
    }
  });
  return newTruncatedState;
};
